
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { HeraBaseService, ISupportPlatform } from "./HeraBaseService";

export interface ICommunity {
    title: string;
    language: string;
    platform_id: string;
    external_id: string;
    url_location: string;
    icon_location: string;
    platform: ISupportPlatform;
}

export class CommunityService extends HeraBaseService {

    protected static instance: CommunityService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!CommunityService.instance) CommunityService.instance = new CommunityService();
        return CommunityService.instance;
    }

    queryCommunities(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ICommunity>> {
        params["platform.platform_id"] = params.platform_id;
        delete params.platform_id;
        return this.report(this.transport.get("/hera/api/v1/support/community", { query: this.normalizeParams(params) }));
    }

    createCommunity(community: Partial<ICommunity>): Promise<SanitizedResponse<ICommunity>> {
        return this.report(this.transport.post("/hera/api/v1/support/community", community));
    }

    updateCommunity(community: Partial<ICommunity>): Promise<SanitizedResponse<ICommunity>> {
        return this.report(this.transport.patch(`/hera/api/v1/support/community/${community.external_id}`, community));
    }

    deleteCommunity(id: string): Promise<SanitizedResponse<ICommunity>> {
        return this.report(this.transport.delete(`/hera/api/v1/support/community/${id}`));
    }

}

